export default __webpack_public_path__ + "static/media/duoTower.jpg?.b876a891";